import { Injectable } from '@angular/core';

@Injectable()
export class SplashEffects {
  dialogRef;

  constructor() {}
}
